import type { BeneficiaryAgencyScope } from '@UI/Pages/Beneficiaries/BeneficiaryList/Filters/BeneficiaryAgencyScope';
import buildAgencyScopeOptions from '@UI/Pages/Beneficiaries/BeneficiaryList/Filters/Helpers/buildAgencyScopeOptions';
import type { HomeScope } from '@UI/Pages/Home/Signals/homeScopeSignal';
import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';

/** Arguments of `BeneficiaryFilterView.setAgencyScope`, plus the label of the matching "Agence" option. */
export type BeneficiaryListScope = {
	readonly scope: BeneficiaryAgencyScope;
	readonly facilityIds: readonly number[];
	readonly label: string;
};

/**
 * Translates the home Périmètre into the "Agence" filter of the dossier list. An organization
 * omitted from the options (single organization) falls back to "Toutes mes agences", which is
 * the same set of agencies.
 */
const resolveBeneficiaryListScope = (
	scope: HomeScope,
	organizations: readonly ComposedOrganization[],
): BeneficiaryListScope => {
	const options = buildAgencyScopeOptions(organizations);
	const key = scope.kind === 'all' ? 'all' : `${scope.kind}:${scope.id}`;
	const option = options.find((candidate) => candidate.key === key) ?? options[0];

	if (option === undefined) {
		return { scope: { type: 'all' }, facilityIds: [], label: 'Toutes mes agences' };
	}

	return { scope: option.scope, facilityIds: option.facilityIds, label: option.label };
};

export default resolveBeneficiaryListScope;
